<template>
	<div class="app-wrapper">
		<header>
			<div class="bar-status">
				<check-server :connection="connetion" :checkProcess="checkConnect" />
				<div v-if="headTitle.point">
					<span>{{ headTitle.point }}</span>
					<span v-show="headTitle.point && headTitle.session">:</span><br>
					<span v-show="headTitle.session">{{ headTitle.session }}</span>
				</div>
			</div>
			<div v-if="session_id || debug" class="button-block">
				<rc-button class="full-width full-height" @click="menuOpen = !menuOpen">=</rc-button>
			</div>
		</header>

		<div class="content">
			<router-view />
		</div>
		<transition name="show-menu">
			<aside v-if="menuOpen" @click.stop="menuOpen = !menuOpen">
				<div class="aside-inner" @click.stop="">
					<nav>
						<router-link v-if="session_id" :to="{ name: 'exhibSelector' }" class="nav-link">Выбрать
							сессию</router-link>
						<rc-button v-if="debug" @click="btnChangeDebug">Выключить отладку</rc-button>
						<rc-button v-if="debug" @click="btnUnlogin">Exit</rc-button>
						<rc-button v-if="debug" @click="btnStorageDataUpd">Storage</rc-button>
						<rc-button v-if="debug" @click="btnClearData">clear</rc-button>
					</nav>
					<div v-if="count_order > 0" class="sending-status">
						<p><strong>Ожидает отправки: {{ count_order }}</strong></p>
					</div>
					<div v-if="debug">
						<p>Режим отладки</p>
						<ul>
							<li>localStorage: {{ count_storage }}</li>
							<li v-for="code_item in code_list">
								{{ code_item }}
							</li>
							<li>===========</li>
							<li v-for="storage_item in storageDegug">
								{{ storage_item }}
							</li>
						</ul>
					</div>
				</div>
			</aside>
		</transition>
		<rc-toast v-model:show="modalShow">{{ modalMessage }}</rc-toast>
	</div>
</template>

<script>
import router from '@/router';
import store from './store';
import axios from 'axios'
import RcToast from './components/ui/rc-toast.vue';
export default {
	data() {
		return {
			toCheckServer: null,
			timeToCheckTs: 20000,
			// connetion: false,
			checkConnect: false,
			menuOpen: false,
			count_storage: 0,
			// packForShipmentArray: [],
			// 
			// storageDegug: [],
			// danger: false,
			// modal
			modalShow: false,
			modalMessage: null,
		};
	},
	async created() {
		// const user_id = this.$store.state.state_user.id
		window.addEventListener('beforeunload', (e) => {
			// this.danger = true
			if (this.count_order > 0) {
				// setTimeout(() => this.danger = false, 3000)
				e.preventDefault();
				e.returnValue = ``;
			}
			// console.log(this.count_order)
		});
	},
	watch: {
		$route(to, from) {
			this.menuOpen = false;
		}
	},
	computed: {
		user_id() {
			return store.getters.user_id;
		},
		headTitle() {
			const [point, session] = store.getters.mainTitle;
			return { point, session };
		},
		code_list() {
			// return store.getters.get_scaned_code
			return store.state.orderForShipment;
		},
		count_order() {
			return store.getters.order_for_shipment_length || 0;
		},
		connetion() {
			return store.getters.server_info.status;
		},
		// session синонимично event
		session_id() {
			return store.getters.event_id;
		},
		debug() {
			return store.getters.debug;
		}
	},
	async beforeMount() {
		store.commit('setUserId', await store.dispatch('uuidv4'));
		const user_info = store.state.user;
		if (!!user_info.aproved && user_info.id) {
			router.push({ name: 'exhibSelector' });
		}
		else {
			router.push({ name: 'login' });
		}
		this.checkServer();
		this.getLocalOrderForShipment();
	},
	beforeUnmount() {
		clearTimeout(this.toCheckServer);
	},
	methods: {
		async checkServer() {
			this.checkConnect = true;
			store.dispatch('prepareData');
			let next_timeout_check_ts = this.timeToCheckTs;
			const data_for_shipment = store.getters.pack_for_shipment.length > 0
				? store.getters.pack_for_shipment.map((item_code) => {
					return {
						code: item_code.code,
						session_id: item_code.session_id,
						readed_ts: item_code.readed_ts
					};
				}) : [];
			await axios({
				method: 'post',
				url: 'https://mobile-dev.expo-stat.ru/api/v2/ping',
				data: {
					uuid: store.getters.user_id,
					login: store.getters.user_name,
					point: store.getters.exhib_id,
					session: store.getters.event_id,
					debug: this.debug,
					data: data_for_shipment
				}
			}).then((response) => {
				this.checkConnect = false;
				// store.commit('update_server_info', {
				// 	status: true,
				// 	status_ts: Date.now()
				// })
				if (response.data.result) {
					const sended_ts = Date.now();
					store.getters.pack_for_shipment.forEach(item_code => {
						store.commit('updateScanedCodeListItem', [item_code.code_uuid, {
							sended: true,
							sended_ts: sended_ts
						}]);
					});
					store.commit('clearPackForShipment');
				}
				else {
					store.getters.pack_for_shipment.forEach(item_code => {
						store.commit('addOrderForShipment', {
							code_uuid: item_code.code_uuid,
							code: item_code.code,
							session_id: item_code.session_id,
							readed_ts: item_code.readed_ts,
						});
					});
				}
				return [response.data.command, response.data.result, response.data.content_html];
			}).then(data => {
				const [command, result, content] = data;
				store.commit('update_server_info', {
					status: true,
					status_ts: Date.now()
				});
				// console.log(command)
				// next_timeout_check_ts = Date.now() - store.getters.server_info.status_ts
				// next_timeout_check_ts = (next_timeout_check_ts > this.timeToCheckTs + 500 || store.getters.order_for_shipment_length > 0)
				// 	? 1000
				// 	: this.timeToCheckTs;
				// 24.09: обработать команды от сервера
				if (command) {
					switch (command) {
						case 'is_unlogined':
							// store.dispatch('serverUnlogin', null)
							store.commit('setUserAprove', false);
							store.commit('setExhib', { id: null, label: null });
							store.commit('setEvent', { id: null, label: null, start_ts: null, end_ts: null });
							router.push({ name: 'login' });
							break;
						case 'set_point':
							store.commit('setExhib', { id: null, label: null });
							router.push({ name: 'exhibSelector' });
							break;
						case 'set_session':
							router.push({ name: 'exhibSelector' });
							break;
						case 'clear_data':
							store.commit('setUserAprove', false);
							store.commit('setExhib', { id: null, label: null });
							store.commit('clearOrderForShipment');
							router.push({ name: 'login' });
							break;
						case 'new_message':
							if (content) {
								this.modalShow = true
								this.modalMessage = content
							}
							break;
						case 'debug_mode':
							store.commit('switchDebugMode', result);
							break;
					}
				}
			}).catch(err => {
				this.checkConnect = false;
				store.commit('update_server_info', {
					status: false,
					status_ts: Date.now()
				});
				for (let item_code of store.getters.pack_for_shipment) {
					store.commit('addOrderForShipment', {
						code_uuid: item_code.code_uuid,
						code: item_code.code,
						session_id: item_code.session_id,
						readed_ts: item_code.readed_ts,
					});
				}
			});
			clearTimeout(this.toCheckServer);
			this.toCheckServer = setTimeout(() => {
				this.checkServer();
			}, next_timeout_check_ts);
		},
		getLocalOrderForShipment() {
			const local_order_for_shipment = localStorage.getItem('orderForShipment');
			if (local_order_for_shipment) {
				for (let item_code of JSON.parse(local_order_for_shipment)) {
					if (item_code.code_uuid) {
						store.commit('addOrderForShipment', (item_code.code_uuid, {
							code_uuid: item_code.code_uuid,
							code: item_code.code,
							readed_ts: item_code.readed_ts,
							session_id: item_code.session_id
						}));
					}
				}
			}
		},
		btnClearData() {
			store.commit('setUserAprove', false);
			store.commit('setExhib', { id: null, label: null });
			store.commit('setEvent', { id: null, label: null, start_ts: null, end_ts: null });
			store.commit('clearPackForShipment');
			store.commit('clearOrderForShipment');
			clearTimeout(this.toCheckServer);
			router.push({ name: 'login' });
		},
		btnUnlogin() {
			store.commit('setUserAprove', false);
			store.commit('setExhib', { id: null, label: null });
			store.commit('setEvent', { id: null, label: null, start_ts: null, end_ts: null });
			router.push({ name: 'login' });
		},
		btnChangeDebug() {
			store.commit('switchDebugMode', !store.getters.debug);
		},
		btnStorageDataUpd() {
			const storageShipment = localStorage.getItem('orderForShipment');
			console.log('code_list: -> ', storageShipment);
			if (storageShipment) {
				const storage_arr = JSON.parse(storageShipment);
				console.log(storage_arr);
				this.count_storage = storage_arr.length;
			}
			this.storageDegug = [];
			this.storageDegug.push(localStorage.getItem('user_name'));
			this.storageDegug.push(localStorage.getItem('user_uuid'));
			this.storageDegug.push(localStorage.getItem('user_aproved'));
			this.storageDegug.push(localStorage.getItem('exhib_id'));
		},
		modalShowing(props) {
			const { state, message } = props;
			console.log(props);
			this.modalShow = state;
			this.modalMessage = message;
		},
		testToast() {
			const prop = { state: true, message: 'Test 1' }
			this.modalShowing(prop);
		},
	},
	components: { RcToast }
}
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	margin: 0;
	padding: 0;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 16px;
	color: #404040;
}

.app-wrapper {
	display: grid;
	width: 100%;
	height: 100vh;
	grid-template-columns: [header-start content-start aside-start] 1fr [header-end content-end aside-end];
	grid-template-rows: [header-start] auto [header-end content-start aside-start] 1fr [content-end aside-end];
}

header {
	grid-area: header;
	display: grid;
	grid-template-columns: [title-start] 1fr [title-end button-start] 60px [button-end];
	grid-template-rows: [title-start button-start] 1fr [title-end button-end];
	background: #004080;
	color: #fff;
	line-height: 1.15rem;
	min-height: 3rem;
	max-height: 5rem;
	padding: 4px;
}

.bar-status {
	display: flex;
	align-items: start;
	gap: 15px;
	grid-area: title;
	overflow: hidden;
}

.button-block {
	grid-area: button;
}

.content {
	grid-area: content;
}

aside {
	grid-area: aside;
	display: flex;
	justify-content: end;
	width: 100%;
	background: rgba(0, 0, 0, .5);
	transition: opacity .5s;
	z-index: 200;
}

.aside-inner {
	width: 300px;
	height: 100%;
	background: #FFF;
	/* box-shadow: 0px -10px 10px 10px rgba(0, 0, 0, .25); */
	transition: transform .5s;
	border-left: 1px solid #e0e0e0;
}

aside.show-menu-enter-from {
	opacity: 0;
}

aside.show-menu-enter-to {
	opacity: 1;
}

aside.show-menu-leave-from {
	opacity: 1;
}

aside.show-menu-leave-to {
	opacity: 0;
}

aside.show-menu-enter-from .aside-inner {
	transform: translateX(100%);
}

aside.show-menu-enter-to .aside-inner {
	transform: translateX(0);
}

aside.show-menu-leave-from .aside-inner {
	transform: translateX(0);
}

aside.show-menu-leave-to .aside-inner {
	transform: translateX(100%);
}

nav {
	display: flex;
	gap: 5px;
	flex-direction: column;
	padding: .1rem;
}

nav .nav-link {
	display: block;
	width: 100%;
	padding: 1rem;
	background: #e0e0e0;
	text-decoration: none;
	color: #404040;
}

nav .nav-link.router-link-active {
	color: #4080f0;
	font-weight: bold;
}

.sending-status {
	padding: .5rem;
}

.rc-btn {
	font-size: 1rem;
	padding: .5rem;
	background: #4080f0;
	border: 1px solid #4080f0;
	border-radius: 2px;
	color: #fff;
}

.rc-form-select {
	width: 100%;
	max-width: 100%;
	font-size: 1rem;
	padding: .5rem;
	background-color: #fff;
	border: 1px solid #4080f0;
	border-radius: 2px;
}

.full-width {
	width: 100%;
}

.full-height {
	height: 100%;
}

.block-form {
	position: relative;
	max-width: 540px;
	margin: 0 auto;
	padding: 1rem 1rem 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
}
</style>
